// extracted by mini-css-extract-plugin
export default {"cursor":"Mouse_cursor__9n2C6"};